import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  id: yup.number().nullable(),
});

export const useToggleSurveyPublishMutation = (options = {}) => {
  var queryClient = useQueryClient();

  return useMutation(
    async (dto) => {
      var req = requestSchema.validateSync(dto, {
        strict: true,
      });

      return await http.post(HTTP_ENDPOINTS.surveys.togglePublish(req.id));
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.surveys.one],
        });
        options.onSuccess?.(...args);
      },
    },
  );
};
